<script lang="ts" setup>
import { useAssessmentTestCompiling } from '@hooks/assessments/assessment-test-compiling.hook'
import { useAssessmentTestControl } from '@hooks/assessments/assessment-test-control.hook'

import { AppLogoDomain } from '@UI/Logos/AppLogoDomain'
import BlockCircularProgress from '@Blocks/Assessment/BlockCircularProgress.vue'

defineOptions({
  name: 'SectionAssessmentTestCompiling',
})

const { options } = useAssessmentTestCompiling()
const { setSubmitCompiling } = useAssessmentTestControl()

</script>

<template>
  <div class="assessment-compiling">
    <div class="assessment-compiling__header">
      <AppLogoDomain />
    </div>
    <div class="assessment-compiling__body">
      <BlockCircularProgress
        :options="options"
        @click:finished="setSubmitCompiling"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Sections/Assessment/SectionAssessmentTestCompiling.scss" />
